<ng-container
  *transloco="let t; prefix: 'sell-with-us.enlist-property-section'"
>
  <div class="grid lg:grid-cols-2 gap-10 mb-10">
    <div
      class="bg-primary-700 flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1"
    >
      <div class="flex flex-col gap-4 mb-5">
        <h3 class="rfs:text-3xl text-white">
          {{ t("card01.title") }}
        </h3>
        <p class="text-primary-50">
          {{ t("card01.text") }}
        </p>
      </div>
      <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
        <div class="flex items-end">
          <button class="btn-primary" [localizedRouterLink]="'/property-upload-wizard'">{{ t("card01.button") }}</button>
        </div>
        <div class="w-full flex justify-end lg:w-auto lg:block">
          <img
            class="lg:h-[100px] xl:h-auto"
            src="./assets/sell-with-us/unico-property.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="bg-[#FFE6DC] flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1"
    >
      <div class="flex flex-col gap-4 mb-5">
        <h3 class="rfs:text-3xl text-black">
          {{ t("card02.title") }}
        </h3>
        <p class="text-gray-950">
          {{ t("card02.text") }}
        </p>
      </div>
      <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
        <div class="flex flex-col justify-between gap-4">
          <img
            class="max-w-[122px]"
            src="./assets/sell-with-us/experts-avatars.png"
            alt=""
          />
          <button
            (click)="generalCallback()"
            class="btn-secondary hover:bg-transparent hover:text-black hover:border-black"
          >
            {{ t("card02.button") }}
          </button>
        </div>
        <div class="w-full flex justify-end lg:w-auto lg:block">
          <img
            class="lg:h-[130px] xl:h-auto"
            src="./assets/sell-with-us/unico-experts.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  <div class="bg-white rounded-small p-8">
    <div class="mb-10 max-w-[970px] min-[1536px]:max-w-[1110px]">
      <h3 class="rfs:text-3xl text-black mb-3">
        {{ t("title") }}
      </h3>
      <p class="text-gray-700">
        {{ t("description") }}
      </p>
    </div>
    <div class="rounded-small border border-gray-300 p-6 mb-10">
      <div class="mb-10">
        <ul class="flex flex-col md:flex-row gap-8 md:gap-20">
          <li class="flex gap-3">
            <div class="pt-1"><i class="icon-check text-primary-700"></i></div>
            <div>
              {{ t("panel.item01") }}
            </div>
          </li>
          <li class="flex gap-3">
            <div class="pt-1"><i class="icon-check text-primary-700"></i></div>
            <div>{{ t("panel.item02") }}</div>
          </li>
          <li class="flex gap-3">
            <div class="pt-1"><i class="icon-check text-primary-700"></i></div>
            <div>{{ t("panel.item03") }}</div>
          </li>
        </ul>
      </div>
      <div
        class="flex justify-between items-center bg-primary-200 rounded-small p-3"
      >
        <div class="flex flex-wrap items-center gap-4">
          <div class="flex justify-between items-center w-full lg:w-auto">
            <div class="text-primary-700 rfs:text-xl font-semibold">95%</div>
            <div class="block lg:hidden">
              <img
                class="min-w-[20px]"
                src="./assets/sell-with-us/smile-icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="text-gray-950 text-xs sm:text-base">
            {{ t("panel.banner") }}
          </div>
        </div>
        <div class="hidden lg:block">
          <img
            class="min-w-[20px]"
            src="./assets/sell-with-us/smile-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="max-w-[200px] mb-10">
      <button class="btn-primary" [localizedRouterLink]="['/services/photography']" >{{ t("button") }}</button>
    </div>
    @if (componentLoaded) {
      <div compareImages class="compare-slider-container">
        <div class="compare-slider-image first-image">
          <span class="compare-slider-tag first-tag">{{ t("before") }}</span>
          <span class="compare-slider-tag second-tag">{{ t("after") }}</span>
        </div>
        <div class="compare-slider-image second-image"></div>
        <div class="compare-slider-separator">
          <div class="compare-slider-handle">
            <img
              src="./assets/sell-with-us/dragHandle.png"
              alt=""
              draggable="false"
            />
          </div>
        </div>
      </div>
    } @else {
      <div class="compare-slider-container bg-gray-100">
        <div class="w-[150px] mx-auto h-full">
          <app-loader [withBackground]="false" variant="secondary"></app-loader>
        </div>
      </div>
    }
  </div>
</ng-container>
